var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#CBCCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 12.6H9V11H7.4V12.6ZM8.2 3C7.35131 3 6.53737 3.33714 5.93726 3.93726C5.33714 4.53737 5 5.35131 5 6.2H6.6C6.6 5.77565 6.76857 5.36869 7.06863 5.06863C7.36869 4.76857 7.77565 4.6 8.2 4.6C8.62435 4.6 9.03131 4.76857 9.33137 5.06863C9.63143 5.36869 9.8 5.77565 9.8 6.2C9.8 7.8 7.4 7.6 7.4 10.2H9C9 8.4 11.4 8.2 11.4 6.2C11.4 5.35131 11.0629 4.53737 10.4627 3.93726C9.86263 3.33714 9.04869 3 8.2 3Z",
    fill: "#262555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.54c83ca8f52286e88b9164f9f584fc7f.svg";
export { ForwardRef as ReactComponent };